module.exports = __webpack_public_path__ + "img/symbol_13.631da2af.png";